import React, { useEffect, useState } from "react"
import { connect } from "react-redux";
import * as layoutService from "../../view/layoutService";
import { withMainLayout } from "../../view/LayoutHOCs";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";
import { useHistory } from "react-router-dom";
import { ArrowLeft, FileText, Code, Target, Wrench, BookOpenText } from "lucide-react";
import PageHeader from "./PageHeader";
import GeneralInfoSection from "./GeneralInfoSection";
import TabSection from "./TabSection";
import TabList from "./TabList";
import RuleTab from "./rule/RuleTab";
import ScriptTab from "./script/ScriptTab";
import TargetTypeTab from "./target-type/TargetTypeTab";
import RemediationTab from "./remediation/RemediationTab";
import CisInfoTab from "./cis/CisInfoTab";
import * as ruleService from "../ruleService";
import * as storeService from "./addRuleStoreService";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "MSBs",
        redirectTo: "/msb",
    },
    {
        text: "Add Rules",
        redirectTo: "/add-rules"
    }
]

function AddRulesPage(props) {

    const history = useHistory();
    const ruleId = props.match.params.id;
    // alert('ruleId: '+ruleId);

    // Tab selection state (lifted from TabSection to allow TabList in sidebar)
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        ruleId && ruleService.getById(ruleId);
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [props.lastRuleLoad])

    useEffect(() => {
        layoutService.setPageTitle('Add Rules')
        layoutService.setBreadcrumbs(breadcrumbs)
        ruleService.loadRuleTargetTypes({ includeAllTargetTypes: true });
        return () => storeService.cleanUpState();
    }, [history.location])

    const tabs = [
        { name: 'Rule', render: <RuleTab />, icon: FileText, disabled: false },
        { name: 'Script', render: <ScriptTab />, icon: Code, disabled: false },
        { name: 'Target Type', render: <TargetTypeTab />, icon: Target, disabled: false },
        { name: 'Remediation', render: <RemediationTab />, icon: Wrench, disabled: false },
        { name: 'CIS', render: <CisInfoTab ruleId={ruleId} />, icon: BookOpenText, disabled: !ruleId }
    ];

    // MSB name shown in Rule Identifier card
    const msbName = props.rule?.msbList?.[0]?.name || '';
    const showHeaderActions = tabs[current]?.name !== 'CIS';

    return (
        <>
            <InfoBoxes />

            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">

                        {/* ── Back Button ── */}
                        {/* <button className="addrules-back-btn-v2" onClick={() => history.push('/msb')}> */}
                        <button className="addrules-back-btn-v2" onClick={() => history.goBack()}>
                            <ArrowLeft />
                            Back
                        </button>

                        {/* ── Main Layout Grid: 1fr sidebar | 3fr content ── */}
                        <div className="addrules-grid-v2">

                            {/* Left Sidebar */}
                                <div className="addrules-sidebar-v2">

                                    {/* Tab navigation buttons */}
                                    <TabList tabs={tabs} current={current} setCurrent={setCurrent} />

                                    {/* Additional Info card — only on edit (when ruleId exists) */}
                                    {ruleId && <GeneralInfoSection />}

                            </div>

                            {/* Right Content Card */}
                            <div className="addrules-content-card-v2">

                                {/* Card header: title + action buttons */}
                                <div className="addrules-content-header-v2">
                                    <h2 className="header-title">Rule Details</h2>
                                    {showHeaderActions &&
                                        <div className="header-actions">
                                            <PageHeader />
                                        </div>
                                    }
                                </div>

                                {/* Active tab content + Rule Identifier card at bottom */}
                                <div className="addrules-form-v2">
                                    <TabSection tabs={tabs} current={current} msbName={msbName} />
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

function mapStateToProps(state) {
    return {
        lastRuleLoad: state.addRulesPage.lastRuleLoad,
        rule: state.addRulesPage.rule,
    }
}

export default withMainLayout(connect(mapStateToProps)(AddRulesPage));
